import React, { useRef, useState } from "react";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";

export default function ImageAvatar(props) {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const handleClick = (inputRef) => {
    inputRef.current.click();
  };

  const handleImageChange = (e, value) => {
    if (e.target.files[0]) {
      const file: File = e.target.files[0];
      var pattern = /image-*/;

      if (!file.type.match(pattern)) {
        alert(t("Only_Image_Allowed"));
      } else {
        props.imageData({
          imageData: e.target.files[0],
          ImageUrl: URL.createObjectURL(e.target.files[0]),
        });
      }
    }
  };

  return (
    <>
      <div
        className="profileImgBG"
        onClick={() => {
          handleClick(inputRef);
        }}
      >
        <img className="profileImage" src={props.source} alt="image" />
        <div className="profileArrowBG">
          <input
            type="file"
            id="img"
            name="img"
            accept="image/*"
            ref={inputRef}
            style={{ display: "none" }}
            onChange={(e, value) => handleImageChange(e, value)}
          />
          <img
            className="uploadImageStyle"
            src={Images.uploadArrow}
            alt="image"
          />
        </div>
      </div>
      {props.errorState && (
        <div style={{ color: "red", fontSize: 12 }}>{props.errorState}</div>
      )}
    </>
  );
}
